import { createComponent } from '@mtfe/sweet';
import { common } from '@mtfe/sweet-utils';
const { createUniqueId } = common;

import tpl from './dom.html';
import style from './style.less';

const popupId = createUniqueId();

const Popup = (props) => {
    const { name, yuan, man, onBtnClick } = props;

    const data = {
        id: popupId,
        name,
        yuan,
        man,
    };
    const events = {
        onCloseClick: function () {
            document.getElementById(popupId).style.display = 'none';
        },
        onBtnClick: function () {
            document.getElementById(popupId).style.display = 'none';
            onBtnClick && onBtnClick();
        },
    };

    const component = createComponent(tpl, { data, style }, events);
    return component;
}

export default Popup;